import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'

import requireLogin from '../auth/requireLogin.js'
import { selectUserCheckResults } from './reducer'
import { checkUserExists, clearUserCheck, setUserCheckResults, clearUserStatus } from './actions'
import { Container, PageTitle, H1, H3, InfoTooltip, PageHeader} from '../components/index.js'
import AccessStatus from '../accessSelfService/AccessStatus'
import AccessGuide from './AccessGuide'
import UserCheckForm from './userCheckForm'
import { selectIsRequestPending } from '../util/index'
import { selectADUserInfo } from '../auth/reducer.js'


class CheckAccessStatus extends Component {
    constructor (props, ...args) {
        super(props, ...args),
        this.state = {
            userId: null,
        }
    }
    
    handleSubmit = (fieldValue) => {
        let { checkUserExists, setUserCheckResults } = this.props
        clearUserStatus()
        setUserCheckResults(null)
        if (!fieldValue.UserId) {
            setUserCheckResults('You need to enter an AD or Email address to check')
        }
        else {
            checkUserExists(fieldValue.UserId)
            this.setState({userId: fieldValue.UserId})
        }
    }
    
    render () {
        let { userCheckResults, userCheckPending, loggedInUser } = this.props
        return (
            <Container section>
                <UserCheckForm onSubmit={this.handleSubmit} actionInProgress={userCheckPending} />
                {
                    userCheckResults==true ? <AccessStatus username={this.state.userId} title='Application Access Status'/> :
                    <div className='access-self-service-error'>{userCheckResults}</div>
                }
            </Container>
        )    
      }
    }
    
export default compose(
    requireLogin('AccessSelfService'),
    connect(state => {
        return {
            userCheckPending: selectIsRequestPending(state, checkUserExists),
            userCheckResults: selectUserCheckResults(state),
            loggedInUser: selectADUserInfo(state),
        }
    }, { checkUserExists, clearUserCheck, setUserCheckResults, clearUserStatus }))(CheckAccessStatus)



// WEBPACK FOOTER //
// ./client/src/accessSelfService/CheckAccessStatus2.js